module.exports = __webpack_public_path__ + "img/0Q3A3375_L_Wood_MockedUp.8c7e00da.jpg";